export const /** AI output type */ OUTPUT_TYPES = {
    IMAGES: 'images',
    WORDS: 'words',
};
